<template>
  <div class="equipment-control">
    <div class="head">
      <equipment-info-module style="margin-top: 15px" @data="getEquipment"></equipment-info-module>
    </div>
    <div class="body">
      <div class="tab" v-if="show.CanAuth">
        <div v-for="item in tabList" :key="item" @click="changeTab(item)" :class="{'active': item === active}">{{item}}</div>
      </div>
      <div class="tab-content" :style="{height: show.CanAuth ? 'calc(100% - 32px)' : '100%'}">
        <control-module style="margin-top: 15px" v-if="show.CanOperate && showOperate && active === '操作空调'" :equipment-info="equipmentInfo"></control-module>
        <auth-module v-if="show.CanAuth && active === '操作授权'"></auth-module>
      </div>
    </div>
  </div>
</template>

<script>

import EquipmentInfoModule from "@/views/equipmentControl/modules/equipmentInfo.vue";
import ControlModule from "@/views/equipmentControl/modules/control.vue";
import AuthModule from "@/views/equipmentControl/modules/auth.vue";

export default {
  name: 'equipmentControl',
  components: {
    AuthModule,
    ControlModule,
    EquipmentInfoModule
  },
  data() {
    return {
      show: {
        CanOperate: false,
        CanAuth: false
      },
      equipmentInfo: {},
      showOperate: false,
      tabList: ['操作空调', '操作授权'],
      active: '操作空调',
    }
  },
  methods: {
    changeTab(tab){
      this.active = tab
    },
    getEquipment(data){
      this.equipmentInfo = data
      this.showOperate = true
    },
    async getCanOperateEquipment() {
      try {
        const { Data } = await this.$post('/BizMemberMemberAuth/CanOperateEquipment')
        this.show = Data
      }catch (e) {
      }
    }
  },
  mounted() {
    this.getCanOperateEquipment()
  }
}

</script>

<style scoped lang="less">
.equipment-control {
  background-color: #FAFAFA;
  .head{
    padding: 10px 20px;
    box-sizing: border-box;
  }
  ::v-deep.equipment-info-module {
    .link {
      display: none !important;
    }
  }
  .body{
    height: calc(100% - 140px);
    color: #999999;
    .tab{
      padding: 10px 20px;
      height: 32px;
      box-sizing: border-box;
      >div{
        display: inline-block;
        vertical-align: top;
        margin-right: 20px;

        &.active{
          color: #00b3f3;
          position: relative;
          &:before{
            position: absolute;
            content: '';
            width: 40px;
            height: 3px;
            background-color: #00b3f3;
            border-radius: 3px;
            left: 50%;
            transform: translateX(-50%);
            bottom: -5px;
          }
        }
      }
    }
    .tab-content{
      overflow-y: auto;
      padding: 10px 20px;
      box-sizing: border-box;
    }
  }
}
</style>
